import React, { useMemo } from 'react'
import { withPrefix, Link } from 'gatsby'
import { findBreadCrumbs } from '../LeftNavigation/utils'
import docsLeftNav from '../../content/navigation/nav.yaml'
import apiRefPagesNav from '../../content/navigation/api.yaml'
import limitedReleaseNav from '../../content/navigation/limited-release.yaml'

export default function BreadCrumbs({ location }) {
  const pathname =
    withPrefix('/') !== '/'
      ? '/' + location.pathname.split('/').slice(2).join('/')
      : location.pathname

  const breadCrumbs = useMemo(() => {
    let navData = docsLeftNav
    if (pathname.includes('/docs/api/')) {
      navData = apiRefPagesNav
    } else if (pathname.includes('/limited-release/')) {
      navData = limitedReleaseNav
    }
    let breadcrumbs = findBreadCrumbs(navData, pathname, '', [])
    if (pathname.includes('/limited-release/')) {
      breadcrumbs.splice(0, 1)
    }
    return breadcrumbs
  }, [pathname])

  return (
    <div className="breadcrumb">
      {breadCrumbs.map((crumb, index) => {
        return (
          <span key={index}>
            <a
              href={crumb.url}
              className={
                index !== breadCrumbs.length - 1
                  ? 'breadcrumbLink'
                  : 'activeBreadcrumbLink'
              }
            >
              {crumb.title}
            </a>{' '}
            {index !== breadCrumbs.length - 1 ? '/' : null}{' '}
          </span>
        )
      })}
    </div>
  )
}
